module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(!_vm.$store.state.isEnhanced) ? [_c('header-area'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.$route.name === 'Home') ? _c('header-events-block') : _c('header-breadcrumbs', {
    staticClass: "hidden-sm-down"
  }), _vm._v(" "), (_vm.sortBar) ? _c('sort-bar', {
    attrs: {
      "sortBar": _vm.sortBar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.meta.filterIsAvailable) ? _c('search-filter') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12",
    class: !_vm.isArticlePage() ? 'col-md-8' : 'col-md-12'
  }, [_c('router-view')], 1), _vm._v(" "), (!_vm.isArticlePage()) ? _c('div', {
    staticClass: "col-md-4 col-12 hidden-sm-down"
  }, [_c('sidebar')], 1) : _vm._e()])], 1), _vm._v(" "), _c('footer-area'), _vm._v(" "), _c('order-reprint-modal')] : [_c('enhanced-view')]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50780142"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1429
// module chunks = 1